import { useTheme } from "../../../../hooks";
import { type IFile } from "../../../../interfaces";

const AttachmentLink = ({ url, filename }: IFile) => {
  const theme = useTheme() as any;
  return (
    <a
      href={url}
      style={{ color: theme.colors.main[9] }}
      target="_blank"
      rel="noreferrer"
      className="attachment-link">
      {filename}
    </a>
  );
};
export default AttachmentLink;
